<div class="w-full svgHeight overflow-auto flex flex-col gap-0">
    <div
        id="sap-chart"
        [ngStyle]="{ width: cameraScale + '%' }"
        class="h-screen overflow-auto mx-auto px-2"></div>
</div>
